import { hasValue } from '../utils';
/** @deprecated */
export var EDocumentStatus;
(function (EDocumentStatus) {
    EDocumentStatus["Attached"] = "attached";
    EDocumentStatus["Delayed"] = "delayed";
    EDocumentStatus["Failed"] = "failed";
})(EDocumentStatus || (EDocumentStatus = {}));
export var EDocumentApiStatus;
(function (EDocumentApiStatus) {
    EDocumentApiStatus["Accepted"] = "accepted";
    EDocumentApiStatus["Stored"] = "stored";
    EDocumentApiStatus["Processing"] = "processing";
    EDocumentApiStatus["Failed"] = "failed";
    EDocumentApiStatus["Degraded"] = "degraded";
    EDocumentApiStatus["Ready"] = "ready"; // все ок
})(EDocumentApiStatus || (EDocumentApiStatus = {}));
export const isDelayedApiStatus = (status) => {
    return (hasValue(status) &&
        [
            EDocumentApiStatus.Accepted,
            EDocumentApiStatus.Stored,
            EDocumentApiStatus.Processing
        ].includes(status));
};
//# sourceMappingURL=document.enum.js.map